import React from "react";

import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import PinterestIcon from "@mui/icons-material/Pinterest";

import { useUserContext } from "../../contexts/UserContext";
import { Grid } from "../../UI/Grid";
import { Typography } from "../../UI/Typography";
import { SnapchatIcon } from "../SnapchatIcon";
import { TiktokIcon } from "../TiktokIcon";
import { Skeleton } from "../../UI/Skeleton";

// X (formerly Twitter) Icon Component
const XIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
  </svg>
);

const ICONS = {
  x: <XIcon />,
  twitter: <XIcon />, // Keep twitter key for backward compatibility
  instagram: <InstagramIcon />,
  snapchat: <SnapchatIcon />,
  youtube_channel: <YouTubeIcon />,
  pinterest: <PinterestIcon />,
  tiktok: <TiktokIcon />,
};

export const UserSocialAccounts = () => {
  const { user, isLoading } = useUserContext();

  return (
    <>
      {isLoading && <Skeleton width={250} variant="text" />}
      {!isLoading && (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography fontWeight={600}>Social Accounts:</Typography>
          </Grid>
          <Grid item container spacing={1}>
            {user?.socialAccounts.map((sa, idx) => (
              <Grid item xs key={idx}>
                <Grid container spacing={1} wrap="nowrap">
                  <Grid item>{ICONS[sa.type]}</Grid>
                  <Grid item xs>
                    {sa.name}
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
      )}
    </>
  );
};
